import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';

// TODO: Replace with real Firebase config
const firebaseConfig = {
  projectId: 'kairos-zaxis',
  appId: '1:202655224700:web:0fed390c044624acdd0af9',
  apiKey: 'AIzaSyCaMvzIHybE9AGATQVoe1IidkiImYD9woE',
  authDomain: 'kairos-zaxis.firebaseapp.com',
  storageBucket: 'kairos-zaxis.firebasestorage.app'
};

import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes), 
    provideClientHydration(),
    provideHttpClient(withFetch()),
    provideFirebaseApp(() => initializeApp(firebaseConfig)),
    provideAuth(() => getAuth()),
    provideCharts(withDefaultRegisterables())
  ]
};
